<template>
    <DataTable :value="tableData" class="p-datatable-sm" :paginator="true" :rows="rowsPerPage" :first="first"
        :totalRecords="totalRecords" :rowsPerPageOptions="[5, 10, 20]" :lazy="true" @page="onPage">
        <Column  header="">
           
        </Column>
        <Column v-for="(col, index) in columns" :key="index" :field="col.field" :header="col.header"
            :sortable=col.sortable class="whitespace-nowrap" :bodyStyle="{ whiteSpace: 'nowrap' }" />
        <Column field="role" header="Role" class="whitespace-nowrap" :bodyStyle="{ whiteSpace: 'nowrap' }">
            <template #body="{ data }">
                <span>{{ formatRole(data.role) }}</span>
            </template>
        </Column>
        <Column field="status" header="Status">
            <template #body="{ data }">
                <Select v-if="isSuperAdmin" v-model="data.enabled" :options="data.enabled ? disableOption : enableOption"
                    optionLabel="label" optionValue="value" class="w-full md:w-8rem accent-select" size="small"
                    @change="onStatusChange(data)"><template #value="{ value }">
                        <span>{{ value ? 'Enable' : 'Disable' }}</span>
                    </template></Select>
                <span v-else>{{ data.enabled ? 'Enable' : 'Disable' }}</span>
            </template>
        </Column>
         <Column header="" class="text-right">
            <template #body="{ data }">
                <div v-if="isSuperAdmin" class="flex justify-content-end">
                    <Button type="button" icon="pi pi-ellipsis-v" class="p-button-text p-button-rounded p-button-plain"
                        @click="toggleMenu($event, data)" aria-haspopup="true" aria-controls="overlay_menu" />
                    <Menu ref="menu" id="overlay_menu" :model="menuItems" :popup="true">
                        <template #item="{ item, props }">
                            <a v-bind="props.action" :class="item.class">
                                <span v-bind="props.label">{{ item.label }}</span>
                            </a>
                        </template>
                    </Menu>
                </div>
            </template>
        </Column>
        <template #paginatorstart>
            <div class="text-sm Caption">
                Showing {{ tableData.length }} of {{ totalRecords }} records
            </div>
        </template>
        <template #empty>
            <div class="flex align-items-center justify-content-center" style="min-height: calc(100vh - 600px)">
                <div class="text-center">
                    <i class="pi pi-inbox" style="font-size: 2rem; color: var(--surface-400)"></i>
                    <p class="mt-2 text-color-secondary">No Data found</p>
                </div>
            </div>
        </template>
    </DataTable>
</template>
<script setup>
import { ref,defineProps,defineEmits } from "vue";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Menu from 'primevue/menu';
import Button from 'primevue/button';
import Select from 'primevue/select';
defineProps({
    tableData: null,
    isLoading: Boolean,
    rowsPerPage: Number,
    totalRecords: Number,
    currentPage: Number,
    isSuperAdmin: Boolean,
    first: {
        type: Number,
        default: 0
    }
})
const emit = defineEmits(["page-change", "status-change", "edit-Admin", "delete-Admin"]);
const menu = ref(null);
const selectedRow = ref(null);
const enableOption = [{ label: "Enable", value: true }];
const disableOption = [{ label: "Disable", value: false }];
const columns = [
    { field: 'username', header: 'Name', sortable: false },
];
const formatRole = (role) => {
    if (!role) return "";
    return role.replace(/_/g, " ").toUpperCase();
};
const menuItems = ref([
    {
        label: "Edit User",
        command: () => emit("edit-Admin", selectedRow.value),
    },
    {
        label: "Delete",
        class: 'red-menu-item',
        command: () => emit("delete-Admin", selectedRow.value),
    },
]);

const toggleMenu = (event, rowData) => {
    selectedRow.value = rowData;
    menu.value.toggle(event);
};
const onStatusChange = (data) => {
    emit("status-change", data);

};
const onPage = (event) => {
    const page = Math.floor(event.first / event.rows) + 1;
    const limit = event.rows;
    emit("page-change", { page, limit });
}
</script>
<style scoped>
.p-button-text.p-button-rounded.p-button-plain {
    color: var(--black-200);
}

.p-datatable .p-column-header-content {
    justify-content: space-between;
}

::v-deep(.p-select) {
    --p-select-sm-font-size: 12px;
    --p-select-color: var(--black-700);
    --p-select-hover-border-color: transparent;
    --p-select-border-color: transparent;
    --p-select-focus-border-color: transparent;
    --p-select-background: transparent;
}
::v-deep(.p-select-sm .p-select-label) {
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.red-menu-item {
    color: #d32f2f !important;
}

.red-menu-item:hover {
    background-color: #ffe6e6 !important;
}

</style>